import { useCallback } from 'react';
import { Metrics } from '../utils/metrics';
import { captureException } from '../utils/sentryUtils';
import { assertChirpMutationReady } from '../utils/chirpMutationGuards';
import { chirpApprovalToApprovalData } from '../utils/chirpApprovalAdapters';
import { useCancelApprovalMutation } from '../../__generated__/chirp/com/hubspot/product/approvals/rpc/ApprovalsRpc.hooks';
import { GET_LATEST_APPROVAL_QUERY } from '../../__generated__/chirp/com/hubspot/product/approvals/rpc/ApprovalsRpc.dfc.new';
export const useChirpCancelApproval = ({
  approvalType,
  approvalAction,
  approvableObjectId,
  usersRecord,
  resolvedData
}) => {
  const [chirpCancelApproval] = useCancelApprovalMutation();
  const cancel = useCallback(note => {
    const validated = assertChirpMutationReady('useChirpCancelApproval', resolvedData, approvableObjectId);
    return chirpCancelApproval({
      variables: {
        approvalId: validated.resolvedData.id,
        note
      },
      update: (cache, {
        data: mutationData
      }) => {
        var _mutationData$result;
        const approvalData = mutationData === null || mutationData === void 0 || (_mutationData$result = mutationData.result) === null || _mutationData$result === void 0 ? void 0 : _mutationData$result.approval;
        if (approvalData) {
          cache.writeQuery({
            query: GET_LATEST_APPROVAL_QUERY,
            variables: {
              approvalType,
              approvalAction,
              approvableObjectId: validated.approvableObjectId
            },
            data: {
              result: {
                approval: approvalData
              }
            }
          });
        }
      }
    }).then(result => {
      var _result$data;
      Metrics.counter('request-recalled').increment();
      const approval = result === null || result === void 0 || (_result$data = result.data) === null || _result$data === void 0 || (_result$data = _result$data.result) === null || _result$data === void 0 ? void 0 : _result$data.approval;
      if (approval) {
        return chirpApprovalToApprovalData(approval, usersRecord, approvalType, approvalAction);
      } else {
        throw new Error('CHIRP cancelApproval succeeded but returned no approval data');
      }
    }).catch(error => {
      captureException(error, {
        extra: {
          fingerprint: 'useApprovalData-cancel-chirp',
          approvalType,
          approvalAction,
          approvalId: validated.resolvedData.id
        }
      });
      throw error;
    });
  }, [chirpCancelApproval, resolvedData, usersRecord, approvalType, approvalAction, approvableObjectId]);
  return cancel;
};